export default {
  getAccountCash: '/courier/api/financial/find/cash/account',
  toWithDrawal: '/courier/api/financial/withdrawal/request',
  helpBuyToWithDrawal: '/v3/helpBuy/withdrawal',
  queryCourierAccountBindInfo: '/courier/api/financial/queryCourierAccountBindInfo',
  courierApplyWithDraw: '/courier/api/financial/courierApplyWithDraw',
  aliPayOauthToken: '/courier/api/financial/aliPayOauthToken',
  queryCancelSwitch: '/courier/api/financial/queryCancelSwitch',
  queryWithdrawBankCard: '/courier/api/v3/queryWithdrawBankCard',
  caculateWithdrawFee: '/courier/api/v3/caculateWithdrawFee',
  withdrawCount: '/courier/api/financial/bankCard/withdraw/count'
}
